var requirejs, require, define;
!function(global) {
    function isFunction(e) {
        return "[object Function]" === ostring.call(e)
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e)
    }
    function each(e, t) {
        if (e) {
            var a;
            for (a = 0; a < e.length && (!e[a] || !t(e[a], a, e)); a += 1)
                ;
        }
    }
    function eachReverse(e, t) {
        if (e) {
            var a;
            for (a = e.length - 1; a > -1 && (!e[a] || !t(e[a], a, e)); a -= 1)
                ;
        }
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t)
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t]
    }
    function eachProp(e, t) {
        var a;
        for (a in e)
            if (hasProp(e, a) && t(e[a], a))
                break
    }
    function mixin(e, t, a, n) {
        return t && eachProp(t, function(t, i) {
            (a || !hasProp(e, i)) && (!n || "object" != typeof t || !t || isArray(t) || isFunction(t) || t instanceof RegExp ? e[i] = t : (e[i] || (e[i] = {}),
            mixin(e[i], t, a, n)))
        }),
        e
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    function scripts() {
        return document.getElementsByTagName("script")
    }
    function defaultOnError(e) {
        throw e
    }
    function getGlobal(e) {
        if (!e)
            return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e]
        }),
        t
    }
    function makeError(e, t, a, n) {
        var i = new Error(t + "\nhttp://requirejs.org/docs/errors.html#" + e);
        return i.requireType = e,
        i.requireModules = n,
        a && (i.originalError = a),
        i
    }
    function newContext(e) {
        function t(e) {
            var t, a;
            for (t = 0; t < e.length; t++)
                if (a = e[t],
                "." === a)
                    e.splice(t, 1),
                    t -= 1;
                else if (".." === a) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1])
                        continue;
                    t > 0 && (e.splice(t - 1, 2),
                    t -= 2)
                }
        }
        function a(e, a, n) {
            var i, r, o, s, c, l, u, d, h, f, p, m, g = a && a.split("/"), b = q.map, v = b && b["*"];
            if (e && (e = e.split("/"),
            u = e.length - 1,
            q.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")),
            "." === e[0].charAt(0) && g && (m = g.slice(0, g.length - 1),
            e = m.concat(e)),
            t(e),
            e = e.join("/")),
            n && b && (g || v)) {
                o = e.split("/");
                e: for (s = o.length; s > 0; s -= 1) {
                    if (l = o.slice(0, s).join("/"),
                    g)
                        for (c = g.length; c > 0; c -= 1)
                            if (r = getOwn(b, g.slice(0, c).join("/")),
                            r && (r = getOwn(r, l))) {
                                d = r,
                                h = s;
                                break e
                            }
                    !f && v && getOwn(v, l) && (f = getOwn(v, l),
                    p = s)
                }
                !d && f && (d = f,
                h = p),
                d && (o.splice(0, h, d),
                e = o.join("/"))
            }
            return i = getOwn(q.pkgs, e),
            i ? i : e
        }
        function n(e) {
            isBrowser && each(scripts(), function(t) {
                return t.getAttribute("data-requiremodule") === e && t.getAttribute("data-requirecontext") === x.contextName ? (t.parentNode.removeChild(t),
                !0) : void 0
            })
        }
        function i(e) {
            var t = getOwn(q.paths, e);
            return t && isArray(t) && t.length > 1 ? (t.shift(),
            x.require.undef(e),
            x.makeRequire(null, {
                skipMap: !0
            })([e]),
            !0) : void 0
        }
        function r(e) {
            var t, a = e ? e.indexOf("!") : -1;
            return a > -1 && (t = e.substring(0, a),
            e = e.substring(a + 1, e.length)),
            [t, e]
        }
        function o(e, t, n, i) {
            var o, s, c, l, u = null, d = t ? t.name : null, h = e, f = !0, p = "";
            return e || (f = !1,
            e = "_@r" + (N += 1)),
            l = r(e),
            u = l[0],
            e = l[1],
            u && (u = a(u, d, i),
            s = getOwn(I, u)),
            e && (u ? p = s && s.normalize ? s.normalize(e, function(e) {
                return a(e, d, i)
            }) : -1 === e.indexOf("!") ? a(e, d, i) : e : (p = a(e, d, i),
            l = r(p),
            u = l[0],
            p = l[1],
            n = !0,
            o = x.nameToUrl(p))),
            c = !u || s || n ? "" : "_unnormalized" + (j += 1),
            {
                prefix: u,
                name: p,
                parentMap: t,
                unnormalized: !!c,
                url: o,
                originalName: h,
                isDefine: f,
                id: (u ? u + "!" + p : p) + c
            }
        }
        function s(e) {
            var t = e.id
              , a = getOwn(C, t);
            return a || (a = C[t] = new x.Module(e)),
            a
        }
        function c(e, t, a) {
            var n = e.id
              , i = getOwn(C, n);
            !hasProp(I, n) || i && !i.defineEmitComplete ? (i = s(e),
            i.error && "error" === t ? a(i.error) : i.on(t, a)) : "defined" === t && a(I[n])
        }
        function l(e, t) {
            var a = e.requireModules
              , n = !1;
            t ? t(e) : (each(a, function(t) {
                var a = getOwn(C, t);
                a && (a.error = e,
                a.events.error && (n = !0,
                a.emit("error", e)))
            }),
            n || req.onError(e))
        }
        function u() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (x.defQueueMap[t] = !0),
                k.push(e)
            }),
            globalDefQueue = [])
        }
        function d(e) {
            delete C[e],
            delete E[e]
        }
        function h(e, t, a) {
            var n = e.map.id;
            e.error ? e.emit("error", e.error) : (t[n] = !0,
            each(e.depMaps, function(n, i) {
                var r = n.id
                  , o = getOwn(C, r);
                !o || e.depMatched[i] || a[r] || (getOwn(t, r) ? (e.defineDep(i, I[r]),
                e.check()) : h(o, t, a))
            }),
            a[n] = !0)
        }
        function f() {
            var e, t, a = 1e3 * q.waitSeconds, r = a && x.startTime + a < (new Date).getTime(), o = [], s = [], c = !1, u = !0;
            if (!v) {
                if (v = !0,
                eachProp(E, function(e) {
                    var a = e.map
                      , l = a.id;
                    if (e.enabled && (a.isDefine || s.push(e),
                    !e.error))
                        if (!e.inited && r)
                            i(l) ? (t = !0,
                            c = !0) : (o.push(l),
                            n(l));
                        else if (!e.inited && e.fetched && a.isDefine && (c = !0,
                        !a.prefix))
                            return u = !1
                }),
                r && o.length)
                    return e = makeError("timeout", "Load timeout for modules: " + o, null, o),
                    e.contextName = x.contextName,
                    l(e);
                u && each(s, function(e) {
                    h(e, {}, {})
                }),
                r && !t || !c || !isBrowser && !isWebWorker || S || (S = setTimeout(function() {
                    S = 0,
                    f()
                }, 50)),
                v = !1
            }
        }
        function p(e) {
            hasProp(I, e[0]) || s(o(e[0], null, !0)).init(e[1], e[2])
        }
        function m(e, t, a, n) {
            e.detachEvent && !isOpera ? n && e.detachEvent(n, t) : e.removeEventListener(a, t, !1)
        }
        function g(e) {
            var t = e.currentTarget || e.srcElement;
            return m(t, x.onScriptLoad, "load", "onreadystatechange"),
            m(t, x.onScriptError, "error"),
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            }
        }
        function b() {
            var e;
            for (u(); k.length; ) {
                if (e = k.shift(),
                null === e[0])
                    return l(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                p(e)
            }
            x.defQueueMap = {}
        }
        var v, y, x, w, S, q = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, C = {}, E = {}, T = {}, k = [], I = {}, A = {}, M = {}, N = 1, j = 1;
        return w = {
            require: function(e) {
                return e.require ? e.require : e.require = x.makeRequire(e.map)
            },
            exports: function(e) {
                return e.usingExports = !0,
                e.map.isDefine ? e.exports ? I[e.map.id] = e.exports : e.exports = I[e.map.id] = {} : void 0
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(q.config, e.map.id) || {}
                    },
                    exports: e.exports || (e.exports = {})
                }
            }
        },
        y = function(e) {
            this.events = getOwn(T, e.id) || {},
            this.map = e,
            this.shim = getOwn(q.shim, e.id),
            this.depExports = [],
            this.depMaps = [],
            this.depMatched = [],
            this.pluginMaps = {},
            this.depCount = 0
        }
        ,
        y.prototype = {
            init: function(e, t, a, n) {
                n = n || {},
                this.inited || (this.factory = t,
                a ? this.on("error", a) : this.events.error && (a = bind(this, function(e) {
                    this.emit("error", e)
                })),
                this.depMaps = e && e.slice(0),
                this.errback = a,
                this.inited = !0,
                this.ignore = n.ignore,
                n.enabled || this.enabled ? this.enable() : this.check())
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0,
                this.depCount -= 1,
                this.depExports[e] = t)
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0,
                    x.startTime = (new Date).getTime();
                    var e = this.map;
                    return this.shim ? void x.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load()
                    })) : e.prefix ? this.callPlugin() : this.load()
                }
            },
            load: function() {
                var e = this.map.url;
                A[e] || (A[e] = !0,
                x.load(this.map.id, e))
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var e, t, a = this.map.id, n = this.depExports, i = this.exports, r = this.factory;
                    if (this.inited) {
                        if (this.error)
                            this.emit("error", this.error);
                        else if (!this.defining) {
                            if (this.defining = !0,
                            this.depCount < 1 && !this.defined) {
                                if (isFunction(r)) {
                                    try {
                                        i = x.execCb(a, r, n, i)
                                    } catch (o) {
                                        e = o
                                    }
                                    if (this.map.isDefine && void 0 === i && (t = this.module,
                                    t ? i = t.exports : this.usingExports && (i = this.exports)),
                                    e) {
                                        if (this.events.error && this.map.isDefine || req.onError !== defaultOnError)
                                            return e.requireMap = this.map,
                                            e.requireModules = this.map.isDefine ? [this.map.id] : null,
                                            e.requireType = this.map.isDefine ? "define" : "require",
                                            l(this.error = e);
                                        "undefined" != typeof console && console.error ? console.error(e) : req.onError(e)
                                    }
                                } else
                                    i = r;
                                if (this.exports = i,
                                this.map.isDefine && !this.ignore && (I[a] = i,
                                req.onResourceLoad)) {
                                    var s = [];
                                    each(this.depMaps, function(e) {
                                        s.push(e.normalizedMap || e)
                                    }),
                                    req.onResourceLoad(x, this.map, s)
                                }
                                d(a),
                                this.defined = !0
                            }
                            this.defining = !1,
                            this.defined && !this.defineEmitted && (this.defineEmitted = !0,
                            this.emit("defined", this.exports),
                            this.defineEmitComplete = !0)
                        }
                    } else
                        hasProp(x.defQueueMap, a) || this.fetch()
                }
            },
            callPlugin: function() {
                var e = this.map
                  , t = e.id
                  , n = o(e.prefix);
                this.depMaps.push(n),
                c(n, "defined", bind(this, function(n) {
                    var i, r, u, h = getOwn(M, this.map.id), f = this.map.name, p = this.map.parentMap ? this.map.parentMap.name : null, m = x.makeRequire(e.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (n.normalize && (f = n.normalize(f, function(e) {
                        return a(e, p, !0)
                    }) || ""),
                    r = o(e.prefix + "!" + f, this.map.parentMap),
                    c(r, "defined", bind(this, function(e) {
                        this.map.normalizedMap = r,
                        this.init([], function() {
                            return e
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        })
                    })),
                    u = getOwn(C, r.id),
                    void (u && (this.depMaps.push(r),
                    this.events.error && u.on("error", bind(this, function(e) {
                        this.emit("error", e)
                    })),
                    u.enable()))) : h ? (this.map.url = x.nameToUrl(h),
                    void this.load()) : (i = bind(this, function(e) {
                        this.init([], function() {
                            return e
                        }, null, {
                            enabled: !0
                        })
                    }),
                    i.error = bind(this, function(e) {
                        this.inited = !0,
                        this.error = e,
                        e.requireModules = [t],
                        eachProp(C, function(e) {
                            0 === e.map.id.indexOf(t + "_unnormalized") && d(e.map.id)
                        }),
                        l(e)
                    }),
                    i.fromText = bind(this, function(a, n) {
                        var r = e.name
                          , c = o(r)
                          , u = useInteractive;
                        n && (a = n),
                        u && (useInteractive = !1),
                        s(c),
                        hasProp(q.config, t) && (q.config[r] = q.config[t]);
                        try {
                            req.exec(a)
                        } catch (d) {
                            return l(makeError("fromtexteval", "fromText eval for " + t + " failed: " + d, d, [t]))
                        }
                        u && (useInteractive = !0),
                        this.depMaps.push(c),
                        x.completeLoad(r),
                        m([r], i)
                    }),
                    void n.load(e.name, m, i, q))
                })),
                x.enable(n, this),
                this.pluginMaps[n.id] = n
            },
            enable: function() {
                E[this.map.id] = this,
                this.enabled = !0,
                this.enabling = !0,
                each(this.depMaps, bind(this, function(e, t) {
                    var a, n, i;
                    if ("string" == typeof e) {
                        if (e = o(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap),
                        this.depMaps[t] = e,
                        i = getOwn(w, e.id))
                            return void (this.depExports[t] = i(this));
                        this.depCount += 1,
                        c(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e),
                            this.check())
                        })),
                        this.errback ? c(e, "error", bind(this, this.errback)) : this.events.error && c(e, "error", bind(this, function(e) {
                            this.emit("error", e)
                        }))
                    }
                    a = e.id,
                    n = C[a],
                    hasProp(w, a) || !n || n.enabled || x.enable(e, this)
                })),
                eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(C, e.id);
                    t && !t.enabled && x.enable(e, this)
                })),
                this.enabling = !1,
                this.check()
            },
            on: function(e, t) {
                var a = this.events[e];
                a || (a = this.events[e] = []),
                a.push(t)
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t)
                }),
                "error" === e && delete this.events[e]
            }
        },
        x = {
            config: q,
            contextName: e,
            registry: C,
            defined: I,
            urlFetched: A,
            defQueue: k,
            defQueueMap: {},
            Module: y,
            makeModuleMap: o,
            nextTick: req.nextTick,
            onError: l,
            configure: function(e) {
                e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/");
                var t = q.shim
                  , a = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    a[t] ? (q[t] || (q[t] = {}),
                    mixin(q[t], e, !0, !0)) : q[t] = e
                }),
                e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (M[e] = t)
                    })
                }),
                e.shim && (eachProp(e.shim, function(e, a) {
                    isArray(e) && (e = {
                        deps: e
                    }),
                    !e.exports && !e.init || e.exportsFn || (e.exportsFn = x.makeShimExports(e)),
                    t[a] = e
                }),
                q.shim = t),
                e.packages && each(e.packages, function(e) {
                    var t, a;
                    e = "string" == typeof e ? {
                        name: e
                    } : e,
                    a = e.name,
                    t = e.location,
                    t && (q.paths[a] = e.location),
                    q.pkgs[a] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "")
                }),
                eachProp(C, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = o(t, null, !0))
                }),
                (e.deps || e.callback) && x.require(e.deps || [], e.callback)
            },
            makeShimExports: function(e) {
                function t() {
                    var t;
                    return e.init && (t = e.init.apply(global, arguments)),
                    t || e.exports && getGlobal(e.exports)
                }
                return t
            },
            makeRequire: function(t, i) {
                function r(a, n, c) {
                    var u, d, h;
                    return i.enableBuildCallback && n && isFunction(n) && (n.__requireJsBuild = !0),
                    "string" == typeof a ? isFunction(n) ? l(makeError("requireargs", "Invalid require call"), c) : t && hasProp(w, a) ? w[a](C[t.id]) : req.get ? req.get(x, a, t, r) : (d = o(a, t, !1, !0),
                    u = d.id,
                    hasProp(I, u) ? I[u] : l(makeError("notloaded", 'Module name "' + u + '" has not been loaded yet for context: ' + e + (t ? "" : ". Use require([])")))) : (b(),
                    x.nextTick(function() {
                        b(),
                        h = s(o(null, t)),
                        h.skipMap = i.skipMap,
                        h.init(a, n, c, {
                            enabled: !0
                        }),
                        f()
                    }),
                    r)
                }
                return i = i || {},
                mixin(r, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var n, i = e.lastIndexOf("."), r = e.split("/")[0], o = "." === r || ".." === r;
                        return -1 !== i && (!o || i > 1) && (n = e.substring(i, e.length),
                        e = e.substring(0, i)),
                        x.nameToUrl(a(e, t && t.id, !0), n, !0)
                    },
                    defined: function(e) {
                        return hasProp(I, o(e, t, !1, !0).id)
                    },
                    specified: function(e) {
                        return e = o(e, t, !1, !0).id,
                        hasProp(I, e) || hasProp(C, e)
                    }
                }),
                t || (r.undef = function(e) {
                    u();
                    var a = o(e, t, !0)
                      , i = getOwn(C, e);
                    i.undefed = !0,
                    n(e),
                    delete I[e],
                    delete A[a.url],
                    delete T[e],
                    eachReverse(k, function(t, a) {
                        t[0] === e && k.splice(a, 1)
                    }),
                    delete x.defQueueMap[e],
                    i && (i.events.defined && (T[e] = i.events),
                    d(e))
                }
                ),
                r
            },
            enable: function(e) {
                var t = getOwn(C, e.id);
                t && s(e).enable()
            },
            completeLoad: function(e) {
                var t, a, n, r = getOwn(q.shim, e) || {}, o = r.exports;
                for (u(); k.length; ) {
                    if (a = k.shift(),
                    null === a[0]) {
                        if (a[0] = e,
                        t)
                            break;
                        t = !0
                    } else
                        a[0] === e && (t = !0);
                    p(a)
                }
                if (x.defQueueMap = {},
                n = getOwn(C, e),
                !t && !hasProp(I, e) && n && !n.inited) {
                    if (!(!q.enforceDefine || o && getGlobal(o)))
                        return i(e) ? void 0 : l(makeError("nodefine", "No define call for " + e, null, [e]));
                    p([e, r.deps || [], r.exportsFn])
                }
                f()
            },
            nameToUrl: function(e, t, a) {
                var n, i, r, o, s, c, l, u = getOwn(q.pkgs, e);
                if (u && (e = u),
                l = getOwn(M, e))
                    return x.nameToUrl(l, t, a);
                if (req.jsExtRegExp.test(e))
                    s = e + (t || "");
                else {
                    for (n = q.paths,
                    i = e.split("/"),
                    r = i.length; r > 0; r -= 1)
                        if (o = i.slice(0, r).join("/"),
                        c = getOwn(n, o)) {
                            isArray(c) && (c = c[0]),
                            i.splice(0, r, c);
                            break
                        }
                    s = i.join("/"),
                    s += t || (/^data\:|\?/.test(s) || a ? "" : ".js"),
                    s = ("/" === s.charAt(0) || s.match(/^[\w\+\.\-]+:/) ? "" : q.baseUrl) + s
                }
                return q.urlArgs ? s + ((-1 === s.indexOf("?") ? "?" : "&") + q.urlArgs) : s
            },
            load: function(e, t) {
                req.load(x, e, t)
            },
            execCb: function(e, t, a, n) {
                return t.apply(n, a)
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = g(e);
                    x.completeLoad(t.id)
                }
            },
            onScriptError: function(e) {
                var t = g(e);
                if (!i(t.id)) {
                    var a = [];
                    return eachProp(C, function(e, n) {
                        0 !== n.indexOf("_@r") && each(e.depMaps, function(e) {
                            return e.id === t.id && a.push(n),
                            !0
                        })
                    }),
                    l(makeError("scripterror", 'Script error for "' + t.id + (a.length ? '", needed by: ' + a.join(", ") : '"'), e, [t.id]))
                }
            }
        },
        x.require = x.makeRequire(),
        x
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState ? interactiveScript : (eachReverse(scripts(), function(e) {
            return "interactive" === e.readyState ? interactiveScript = e : void 0
        }),
        interactiveScript)
    }
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.1.22", commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, ap = Array.prototype, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    if ("undefined" == typeof define) {
        if ("undefined" != typeof requirejs) {
            if (isFunction(requirejs))
                return;
            cfg = requirejs,
            requirejs = void 0
        }
        "undefined" == typeof require || isFunction(require) || (cfg = require,
        require = void 0),
        req = requirejs = function(e, t, a, n) {
            var i, r, o = defContextName;
            return isArray(e) || "string" == typeof e || (r = e,
            isArray(t) ? (e = t,
            t = a,
            a = n) : e = []),
            r && r.context && (o = r.context),
            i = getOwn(contexts, o),
            i || (i = contexts[o] = req.s.newContext(o)),
            r && i.configure(r),
            i.require(e, t, a)
        }
        ,
        req.config = function(e) {
            return req(e)
        }
        ,
        req.nextTick = "undefined" != typeof setTimeout ? function(e) {
            setTimeout(e, 4)
        }
        : function(e) {
            e()
        }
        ,
        require || (require = req),
        req.version = version,
        req.jsExtRegExp = /^\/|:|\?|\.js$/,
        req.isBrowser = isBrowser,
        s = req.s = {
            contexts: contexts,
            newContext: newContext
        },
        req({}),
        each(["toUrl", "undef", "defined", "specified"], function(e) {
            req[e] = function() {
                var t = contexts[defContextName];
                return t.require[e].apply(t, arguments)
            }
        }),
        isBrowser && (head = s.head = document.getElementsByTagName("head")[0],
        baseElement = document.getElementsByTagName("base")[0],
        baseElement && (head = s.head = baseElement.parentNode)),
        req.onError = defaultOnError,
        req.createNode = function(e, t, a) {
            var n = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return n.type = e.scriptType || "text/javascript",
            n.charset = "utf-8",
            n.async = !0,
            n
        }
        ,
        req.load = function(e, t, a) {
            var n, i = e && e.config || {};
            if (isBrowser)
                return n = req.createNode(i, t, a),
                i.onNodeCreated && i.onNodeCreated(n, i, t, a),
                n.setAttribute("data-requirecontext", e.contextName),
                n.setAttribute("data-requiremodule", t),
                !n.attachEvent || n.attachEvent.toString && n.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (n.addEventListener("load", e.onScriptLoad, !1),
                n.addEventListener("error", e.onScriptError, !1)) : (useInteractive = !0,
                n.attachEvent("onreadystatechange", e.onScriptLoad)),
                n.src = a,
                currentlyAddingScript = n,
                baseElement ? head.insertBefore(n, baseElement) : head.appendChild(n),
                currentlyAddingScript = null,
                n;
            if (isWebWorker)
                try {
                    importScripts(a),
                    e.completeLoad(t)
                } catch (r) {
                    e.onError(makeError("importscripts", "importScripts failed for " + t + " at " + a, r, [t]))
                }
        }
        ,
        isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            return head || (head = e.parentNode),
            dataMain = e.getAttribute("data-main"),
            dataMain ? (mainScript = dataMain,
            cfg.baseUrl || (src = mainScript.split("/"),
            mainScript = src.pop(),
            subPath = src.length ? src.join("/") + "/" : "./",
            cfg.baseUrl = subPath),
            mainScript = mainScript.replace(jsSuffixRegExp, ""),
            req.jsExtRegExp.test(mainScript) && (mainScript = dataMain),
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript],
            !0) : void 0
        }),
        define = function(e, t, a) {
            var n, i;
            "string" != typeof e && (a = t,
            t = e,
            e = null),
            isArray(t) || (a = t,
            t = null),
            !t && isFunction(a) && (t = [],
            a.length && (a.toString().replace(commentRegExp, "").replace(cjsRequireRegExp, function(e, a) {
                t.push(a)
            }),
            t = (1 === a.length ? ["require"] : ["require", "exports", "module"]).concat(t))),
            useInteractive && (n = currentlyAddingScript || getInteractiveScript(),
            n && (e || (e = n.getAttribute("data-requiremodule")),
            i = contexts[n.getAttribute("data-requirecontext")])),
            i ? (i.defQueue.push([e, t, a]),
            i.defQueueMap[e] = !0) : globalDefQueue.push([e, t, a])
        }
        ,
        define.amd = {
            jQuery: !0
        },
        req.exec = function(text) {
            return eval(text)
        }
        ,
        req(cfg)
    }
}(this),
define("requirejs", function() {}),
define("acts-sticky-header", ["jquery"], function(e) {
    "use strict";
    var t, a, n = e(window), i = e("#js-stick-window"), r = e(".main-content");
    if (r.hasClass("act-single") || r.hasClass("act-general")) {
        if (!i.length)
            return;
        setTimeout(function() {
            a = i.offset()
        }, 500),
        e(".js-stick-window-placeholder").css({
            height: i.height()
        }),
        n.scroll(function() {
            a && (t = n.scrollTop(),
            r[a.top < t ? "addClass" : "removeClass"]("js-sticky-header"))
        })
    }
}),
define("acts-year-select", ["jquery", "select2"], function(e) {
    "use strict";
    function t(t, i) {
        var a = e(i);
        if (!a.length) return;
        var o = [];
        for (var n = t[1]; n >= t[0]; n--) {
            o.push('<option value="' + n + '">' + n + '</option>');
        }
        a.append(o.join(''));
        a.select2({
            dropdownParent: a.parent(),
            minimumResultsForSearch: 0, // Enables year search by typing
            formatResult: function(result) {
                return e(result.element).val() === '-' ? null : result.text;
            }
        });
    }
    var r = "#js-datatables-year-filter";
    if (e(r).length) {
        t([1922, (new Date).getFullYear()], r);
    }
    e(r + ", .year-filter").on("change", function() {
        var i = this.options[this.selectedIndex].value;
        if (!i || i === '-') return;
        window.location = e(this).hasClass("statutory") 
            ? "/" + i + "/statutory.html" 
            : "/" + i + "/" + i + ".html";
    });
});
define("cookies", ["jquery"], function(e) {
    "use strict";
    var t = e("#cookie-notice")
      , a = "cookies-agreed-state"
      , n = sessionStorage.getItem(a);
    if (0 !== t.length && !n)
        return t.removeClass("hide").find("button.close").on("click", function() {
            sessionStorage.setItem(a, !0)
        }),
        {}
}),
define("datatable-plugins/datatable-extended", ["jquery", "datatables"], function(e) {
    "use strict";
    return e.extend(e.fn.dataTableExt.oSort, {
        "numbered-only-asc": function(e, t) {
            var a = 0;
            return e = parseFloat(e.replace(/[^\d\+]/g, "")),
            t = parseFloat(t.replace(/[^\d\+]/g, "")),
            e > t ? a = 1 : t > e && (a = -1),
            a
        },
        "numbered-only-desc": function(e, t) {
            var a = 0;
            return e = parseFloat(e.replace(/[^\d\+]/g, "")),
            t = parseFloat(t.replace(/[^\d\+]/g, "")),
            e > t ? a = -1 : t > e && (a = 1),
            a
        }
    }),
    e
}),
define("datatable-plugins/datatable-filters", ["jquery", "datatables"], function(e) {
    "use strict";
    function t(t, a) {
        var n = "Number of Act"
          , i = function(e) {
            return e ? "^" + e : ""
        };
        ("public-acts-dtb" === a || "statutory-instruments-dtb" === a) && ("statutory-instruments-dtb" === a && (n = "Number of SI"),
        e("#" + a + "_wrapper").prepend('<div id="DataTables_TableNumber_' + a + '_filter" data-tip="Search by number" class="dataTables_filter"><label>Refine by<input type="search" class="dataTables_filterNumber" data-table="' + a + '" placeholder="' + n + '" /><i class="fa fa-times numberSearchX" aria-label="Clear number search"></i></label></div>')),
        e("#" + a + "_filter label").append('<i class="fa fa-times titleSearchX" aria-label="Clear title search"></i>'),
        e("#" + a + "_filter label input").attr("data-table", a),
        e("#" + a + "_filter label input").attr("id", "titleSearch"),
        e("#public-acts-dtb_filter input").addClass("titleSearch"),
        e("#statutory-instruments-dtb_filter input").addClass("titleSearch"),
        e("#constitutional-amendments-dtb_filter input").addClass("titleSearch"),
        e("#private-acts-dtb_filter input").addClass("titleSearch"),
        e("input.titleSearch").on("keyup", function() {
            e("#" + e(this).data("table")).DataTable().columns(1).search(i(this.value)).draw()
        }),
        e(".dataTables_filterNumber").on("keyup", function() {
            e("#" + e(this).data("table")).DataTable().columns(0).search(i(this.value)).draw()
        }),
        e(".dataTables_filter label input").each(function() {
            var t = e(this)
              , a = t.parent();
            t.bind("propertychange change click keyup input paste", function() {
                "" !== t.val() ? a.addClass("show") : a.removeClass("show")
            })
        }),
        e(".dataTables_filter label .numberSearchX").on("click", function() {
            var t = e(this).prev("input");
            t.val(""),
            t.hasClass("dataTables_filterNumber") && e("#" + t.data("table")).DataTable().search("").columns(0).search("").draw()
        }),
        e(".dataTables_filter label .titleSearchX").on("click", function(t) {
            t.preventDefault(),
            e("#titleSearch").val(""),
            e("#" + e(this).prev("input").data("table")).DataTable().search("").columns(1).search("").draw()
        })
    }
    return {
        initialize: t
    }
}),
define("datatable-plugins/datatable-tooltip", ["jquery", "datatables"], function(e) {
    "use strict";
    e(".datatable tr th").hover(function() {
        var t = e(this).data("tip");
        if (t) {
            e(this).append('<span class="tip">' + t + "</span>");
            var a = e(this).parents("thead")
              , n = a.offset();
            a.on("mousemove", function(t) {
                e(this).find(".tip").css({
                    left: t.pageX - n.left,
                    top: t.pageY - n.top
                })
            })
        }
    }, function() {
        e(".tip").remove()
    })
}),
define("datatable-plugins/datatable-stick-menu", ["jquery", "datatables"], function(e) {
    "use strict";
    function t() {
        var t, a = e(".datatable-breadcrumb"), n = a.outerHeight() + 80, i = a.find("a"), r = i.map(function() {
            var t = e(e(this).attr("href"));
            return t.length ? t : void 0
        });
        i.on("click", function(t) {
            var a = e(this).attr("href")
              , i = "#" === a ? 0 : e(a).offset().top - n;
            e("html, body").stop().animate({
                scrollTop: i
            }, 400),
            t.preventDefault()
        }),
        e(window).scroll(function() {
            var a = e(this).scrollTop() + n
              , o = r.map(function() {
                return e(this).offset().top < a ? this : void 0
            });
            o = o[o.length - 1];
            var s = o && o.length ? o[0].id : "";
            t !== s && (t = s,
            i.parent().removeClass("active").end().filter("[href=#" + s + "]").parent().addClass("active"))
        })
    }
    e(".main-content").hasClass("datatable-multi") && t()
}),
define("datatable-init", ["datatable-plugins/datatable-extended", "datatable-plugins/datatable-filters", "datatable-plugins/datatable-tooltip", "datatable-plugins/datatable-stick-menu"], function(e, t) {
    "use strict";
    var a = 1
      , n = e(".act-general").data("single-column")
      , i = {
        first: n ? "10%" : "15%",
        second: n ? "85%" : "80%"
    }
      , r = function(n, r) {
        var o, s = !0;
        "constitutional-amendments-dtb" === e(r).attr("id") && (s = !1),
        "public-acts-dtb" === e(r).attr("id") || "statutory-instruments-dtb" === e(r).attr("id") ? ("statutory-instruments-dtb" === e(r).attr("id") && (a = 0),
        o = e(r).DataTable({
            searchCols: [{
                regex: !0
            }, {
                regex: !0
            }],
            paging: !1,
            language: {
                search: "Refine by",
                searchPlaceholder: "First letter(s) in title"
            },
            order: [[a, "asc"]],
            aoColumns: [{
                sWidth: i.first
            }, {
                sWidth: i.second
            }, {
                sWidth: "5%",
                sClass: "action-cell"
            }],
            columnDefs: [{
                type: "numbered-only",
                targets: 0
            }]
        })) : o = e(r).DataTable({
            searchCols: [{
                regex: !0
            }],
            bSort: s,
            bFilter: !1,
            paging: !1,
            language: {
                search: "Refine by",
                searchPlaceholder: "First letter(s) in title"
            },
            order: [[a, "asc"]],
            aoColumns: [{
                sWidth: i.second
            }, {
                sWidth: "5%",
                sClass: "action-cell"
            }]
        }),
        t.initialize(o, e(r).attr("id"))
    };
    e(".datatable").each(function(e, t) {
        r(e, t)
    })
}),
define("dropdown", ["jquery", "bootstrap"], function(e) {
    "use strict";
    function t(e) {
        769 > e && a.removeClass("open")
    }
    var a = e(".search-toggle, .mobile-nav-action, .navigation-bar");
    e('[data-toggle="dropdown"]').dropdown(),
    e(window).on("load resize", function() {
        var e = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        t(e)
    }),
    e('[data-toggle="dropdown-remain"]').on("click", function(t) {
        var a = e(this)
          , n = e(a.attr("data-hide")).not(this)
          , i = e(a.attr("data-target"));
        t.preventDefault(),
        e(".search-btn").parent().hasClass("open") ? e(".search-btn").attr("title", "Show the search panel") : e(".search-btn").attr("title", "Hide the search panel"),
        n.each(function(t, a) {
            var n = e(a).attr("data-target");
            e(a).parent().removeClass("open"),
            e(n).removeClass("open")
        }),
        a.parent().toggleClass("open"),
        i.toggleClass("open")
    })
}),
define("faq", ["jquery"], function(e) {
    "use strict";
    function t(t) {
        return e("html, body").animate({
            scrollTop: e(t).offset().top
        }, 500),
        !1
    }
    e(".faq .side-block .arrowed-list a").on("click", function() {
        var a = e(this).attr("href");
        a = a.slice(-1),
        e("a[data-panel=" + a + "]").toggleClass("collapsed"),
        t("a[data-panel=" + a + "]")
    }),
    e("#faqLink-trackingAmendment").on("click", function() {
        var a = e('a[data-panel="2"]');
        a.hasClass("collapsed") ? (e("#js-panel-2").collapse("show"),
        a.removeClass("collapsed"),
        t("#js-panel-2"),
        setTimeout(function() {
            e("#js-panel-js-panel-2-0").collapse("show"),
            e('a[data-panel="2"] > a').removeClass("collapsed")
        }, 350)) : (e("#js-panel-2").collapse("hide"),
        a.addClass("collapsed"),
        e("#js-panel-js-panel-2-0").collapse("hide"),
        e('a[data-panel="2"] > a').addClass("collapsed"))
    });
    var a, n = localStorage.getItem("faqPanel"), i = localStorage.getItem("faqPanelId");
    e(".faq-panel-link").on("click", function(t) {
        t.preventDefault(),
        a = e(this).data("faq"),
        localStorage.setItem("faqPanel", "true"),
        localStorage.setItem("faqPanelId", a),
        window.location = e(this).attr("href")
    }),
    e(document).ready(function() {
        "true" === n && (setTimeout(function() {
            e("#js-panel-" + i).collapse("show"),
            e('a[data-panel="' + i + '"]').removeClass("collapsed")
        }, 200),
        localStorage.removeItem("faqPanel"),
        localStorage.removeItem("faqPanelId"))
    })
}),
define("feedback", ["jquery"], function(e) {
    "use strict";
    function t() {
        o = Math.ceil(10 * Math.random()),
        s = Math.ceil(10 * Math.random()),
        c = o + s,
        l = "<span>" + o + "</span> + <span>" + s + '</span> = <input class="submit---input" type="text" maxlength="2" size="2" required />',
        e(".feedback .submit--generated").html(l),
        r()
    }
    function a() {
        return u === c ? (e(".feedback .submit--generated").removeClass("unvalid").addClass("valid"),
        e(".submit-form").removeClass("overlay"),
        e(".submit-form-overlay").fadeOut("fast"),
        e(".submit--error").addClass("hide"),
        e(".submit--errorEmpty").addClass("hide"),
        f = !0) : ("" === u ? (e(".submit--error").addClass("hide"),
        e(".submit--errorEmpty").removeClass("hide")) : (e(".submit--error").removeClass("hide"),
        e(".submit--errorEmpty").addClass("hide")),
        e(".feedback .submit--generated").removeClass("valid").addClass("unvalid"),
        e(".submit-form").addClass("overlay"),
        e(".submit-form-overlay").fadeIn("fast"),
        f = !1),
        f
    }
    function n() {
        e(".form-fields").addClass("fadeOut"),
        e("html, body").animate({
            scrollTop: 0
        }, 400, function() {
            e(".form-success").removeClass("hide"),
            setTimeout(function() {
                e(".form-fields").addClass("hide"),
                e(".form-success").addClass("fadeIn")
            }, 200)
        })
    }
    function i() {
        d = !1
    }
    function r() {
        e(".form-fields form").on("submit", function(t) {
            return t.preventDefault(),
            e(".feedback .submit--generated").hasClass("valid") ? (u = e(".submit---input").val(),
            "" !== u && (u = Number(u)),
            a(),
            f === !0 && (f = !1,
            n()),
            void 0) : !1
        }),
        e(".submit---input").on("propertychange change keyup input paste", function() {
            window.clearTimeout(h),
            h = window.setTimeout(function() {
                u = e(".submit---input").val(),
                "" !== u && (u = Number(u)),
                a()
            }, 150)
        }),
        e("body").on("keydown", function(t) {
            13 === t.which && (e(".submit-form").hasClass("overlay") ? a() : e(".submit-form").addClass("enter-press"))
        }).on("keyup", function(t) {
            13 === t.which && e(".submit-form").removeClass("enter-press")
        }),
        e(".submit-control i.fa-refresh").on("click", function() {
            d || (d = !0,
            setTimeout(i, 500),
            t(),
            setTimeout(a, 0))
        }),
        e(".submit-form-overlay").on("click", function() {
            a()
        })
    }
    var o, s, c, l, u, d, h, f = !1;
    t()
}),
define("home-image", ["jquery"], function(e) {
    "use strict";
    var t, a = e(".homepage-alt-image"), n = "static/images/homepage/", i = ".png", r = 1, o = 2;
    a.length && (t = Math.floor(Math.random() * (1 + o - r) + r),
    a.attr("src", n + t + i))
}),
define("legislation-pdf", ["jquery", "xmlToJSON", "handlebars"], function(e, t, a) {
    "use strict";
    function n(t) {
        var n = {
            nodes: t.tabs[0].tab
        }
          , i = a.compile(e("#hb-recent-legislation-tabs").html() || "")
          , r = a.compile(e("#hb-recent-legislation-tabs-content").html() || "")
          , o = i(n)
          , s = r(n);
        e(".recent-legislation .nav-tabs").append(o),
        e(".recent-legislation .tab-content").append(s);
        // Add this code to handle the selected tab ARIA attributes
        setTimeout(function() {
            // Set proper ARIA attributes on initial load
            e(".recent-legislation .nav-tabs li").each(function() {
                var $tab = e(this);
                var $tabLink = $tab.find('a');

                // Set the correct aria-selected state based on active class
                if ($tab.hasClass('active')) {
                    $tabLink.attr('aria-selected', 'true');
                    // Optionally add a class for visual styling
                    $tabLink.addClass('visually-selected');
                } else {
                    $tabLink.attr('aria-selected', 'false');
                }
            });
            // Set up click handlers for future tab changes
            e(".recent-legislation .nav-tabs a").on("click", function() {
                var $this = e(this);
                // Update ARIA attributes after tab switch
                setTimeout(function() {
                    // Reset all tabs
                    e(".recent-legislation .nav-tabs a").attr('aria-selected', 'false')
                                                      .removeClass('visually-selected');
                    
                    // Set the newly active tab
                    e(".recent-legislation .nav-tabs li.active a").attr('aria-selected', 'true')
                                                               .addClass('visually-selected');
                }, 50);
            });
        }, 100); // Small delay to ensure the tabs are fully rendered
    }
    e.ajax({
        type: "GET",
        url: "/static/assets/language/en_IE/index-recentLegislation.xml",
        dataType: "xml",
        success: function(e) {
            var a = t.parseXML(e.documentElement, {
                xmlns: !1
            });
            n(a)
        },
        error: function(e, t, a) {
            console.log(e.status),
            console.log(a)
        }
    })
}),
define("navbar", ["jquery"], function(e) {
    "use strict";
    var t = e(".main-content").data("highlight");
    t && e('.navigation-bar .nav li[data-nav="' + t + '"]').addClass("active")
}),
define("scrollTop", ["jquery"], function(e) {
    "use strict";
    var t, a = {
        scrollOffset: 475,
        transitionSpeed: 500
    }, n = e("html, body"), i = e(window), r = e(".js-rise-hook");
    i.scroll(function() {
        t = r.hasClass("show-element"),
        !t && i.scrollTop() > a.scrollOffset ? r.addClass("show-element") : t && i.scrollTop() < a.scrollOffset && r.removeClass("show-element")
    }),
    r.on("click", function() {
        n.animate({
            scrollTop: "0px"
        }, a.transitionSpeed)
    })
}),
!function(e, t) {
    "use strict";
    function a(e) {
        return (e || "").replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1")
    }
    function n(e) {
        return new RegExp(a(e),"gi")
    }
    function i(e, t) {
        e.className || (e.className = t),
        -1 === e.className.indexOf(t) && (e.className += " " + t)
    }
    function r(e, t) {
        e.className.indexOf(t) >= 0 && (e.className = e.className.replace(n(" " + t), ""))
    }
    function o(e, a) {
        i(a, e.FOCUS_CLASS),
        a.scrollIntoView && (a.scrollIntoView(),
        t.body.scrollTop -= 100)
    }
    function s(e, t) {
        r(t, e.FOCUS_CLASS)
    }
    function c(e) {
        return e ? e.innerText || e.textContent || "" : ""
    }
    function l(e, t, i) {
        var r, o, s, c = 0, l = [], u = 0, d = 0, h = 0, f = !1, p = [], m = e.split(""), v = e.length, y = n(t), x = t.length, w = function(e) {
            for (var t, a = [], n = 0, i = e.length; i > n; )
                t = e[n].split(" "),
                a.push(t[0]),
                a.push(t[t.length - 1]),
                n++;
            return a
        };
        for (i = i || {},
        i.wholeWords ? s = new RegExp("(?:[\\s\\W]{1})(" + a(t) + ")(?:[\\s\\W]+)","gi") : i.usesProximity ? s = g(t) : i.useWildcards && (s = b(t)),
        s = s || n(t); v > c; )
            "<" === m[c] && (f = !0),
            f || l.push(c),
            c++,
            f && ">" === m[c] && (f = !1,
            c++);
        for (c = 0,
        o = ""; c < l.length; )
            o += e.charAt(l[c]),
            c++;
        if (r = o.match(s))
            for (i.usesProximity && (r = w(r.filter(function(e) {
                return (e || "").match(g(t))
            }))),
            c = u = 0; c < r.length; )
                i.usesProximity ? (h = o.search(c % 2 === 0 ? s : n(r[c])),
                d = h + r[c].length) : i.useWildcards ? (h = o.search(s),
                d = h + r[c].length) : (h = o.search(s) + r[c].search(y),
                d = h + x),
                p.push({
                    startIndex: l[h + u],
                    endIndex: l[d + u]
                }),
                u += d,
                o = o.substring(d),
                c++;
        return p
    }
    function u(e, t, a) {
        return function(n, i) {
            var r, o, s, c, u, d = 0, h = 0, f = "", g = a.matchIdPrefix || e.MATCH_ID_PREFIX;
            for (o = i.innerHTML,
            u = l(o, t, a),
            c = u.length; c > d; )
                s = u[d],
                r = g + (e.occurrenceNumber += 1),
                f += o.substring(h, s.startIndex),
                f += p(e, r),
                f += o.substring(s.startIndex, s.endIndex),
                f += m(e),
                h = s.endIndex,
                d++;
            return h >= 0 && (f += o.substring(h)),
            c && (i.innerHTML = f),
            c
        }
    }
    function d(e, a) {
        var n = e.matchNumber || 1
          , i = t.getElementById(a ? e.MATCH_ID_PREFIX + (n - 1) : e.MATCH_ID_PREFIX + (n + 1))
          , r = t.getElementById(e.MATCH_ID_PREFIX + n);
        i && s(e, i),
        r && o(e, r)
    }
    function h(e) {
        this.FOCUS_CLASS = e.FOCUS_CLASS || "search-focus",
        this.HIGHLIGHT_TAG = e.HIGHLIGHT_TAG || "span",
        this.HIGHLIGHT_CLASS = e.HIGHLIGHT_CLASS || "highlight",
        this.MATCH_ID_PREFIX = e.MATCH_ID_PREFIX || "search-match-",
        this.matchNumber = 0,
        this.totalMatches = 0,
        this.occurrenceNumber = 0
    }
    var f = function(e, t, a) {
        return e.replace(">", " " + t + '="' + a + '">')
    }
      , p = function(e, t, a) {
        var n = "<" + e.HIGHLIGHT_TAG + ">";
        return n = f(n, "class", e.HIGHLIGHT_CLASS + (a || "")),
        n = f(n, "id", t)
    }
      , m = function(e) {
        return "</" + e.HIGHLIGHT_TAG + "><!-- highlight-closer -->"
    }
      , g = function(e) {
        var t, a = function(e) {
            var t = e.match(/~(\d+)$/);
            return t ? parseInt(t[1], 10) : void 0
        }(e);
        return isNaN(a) ? /^$/ : (e = e.replace(/["']~(\d+)$/g, ""),
        e.replace(/(\w+)(\s+)(\w+)/, function(e, n, i, r) {
            t = new RegExp(n + "(\\s+[\\S]+){" + a + "}\\s+" + r,"ig")
        }),
        t)
    }
      , b = function(e) {
        var t, a, n, i, r, o = function(e) {
            return e.replace(/\*/, "") + "[\\w-]*"
        };
        if (e.match(/\*$/))
            return new RegExp(o(e),"ig");
        for (t = "",
        a = e.split(" "),
        r = 0,
        i = a.length; i > r; )
            n = a[r] || "",
            t += n.match(/\*/) ? o(n) : n,
            i - 1 > r && (t += "\\s+"),
            r++;
        return new RegExp(t,"ig")
    };
    h.prototype.search = function(e, t, a) {
        var i, r, o, s = 0, l = 0, d = 0, h = 0, f = [], p = 0, m = [], v = n(this.MATCH_ID_PREFIX), y = function(e) {
            return Boolean(e.match(/~\d+$/))
        }, x = function(e) {
            return Boolean(e.match(/\*/))
        };
        if (!e || !t)
            return console.log("Invalid parameters received."),
            0;
        for (a = a || {},
        Object.prototype.toString.call(e).match(/array/i) || (e = [e]),
        e = e.map(function(e) {
            return e.replace(/\s+(AND|OR)\s+/gi, ",").replace(/NOT\s+\w+\s?/gi, "");
        }),
        o = [],
        e.forEach(function(e) {
            e.indexOf(",") >= 0 ? o = o.concat(e.split(",")) : o.push(e)
        }),
        e = o.map(function(e) {
            return (e || "").trim()
        }),
        p = e.length; p > l; )
            r = e[l] || "",
            y(r) ? (a.usesProximity = !0,
            f.push(g(r))) : x(r) ? (a.useWildcards = !0,
            f.push(b(r))) : f.push(n(r)),
            m.push(u(this, r, a)),
            l += 1;
        for (h = t.length; h > s; ) {
            if (i = t[s],
            -1 === i.innerHTML.search(v))
                for (l = 0; p > l; )
                    c(i).match(f[l]) && (d += m[l](d, i)),
                    l += 1;
            s += 1
        }
        return this.totalMatches += d,
        d
    }
    ,
    h.prototype.clear = function(e) {
        var a = new RegExp("<" + this.HIGHLIGHT_TAG + ' class="' + this.HIGHLIGHT_CLASS + "(\\s" + this.FOCUS_CLASS + ')?"(\\sid="[\\w-]+")?>',"g");
        e = e || t.body,
        e.innerHTML.search(a) >= 0 && (e.innerHTML = e.innerHTML.replace(a, "").replace(n(m(this)), "")),
        this.matchNumber = this.totalMatches = this.occurrenceNumber = 0
    }
    ,
    h.prototype.nextMatch = function() {
        return this.matchNumber + 1 <= this.totalMatches && (this.matchNumber += 1,
        d(this, !0)),
        this.matchNumber
    }
    ,
    h.prototype.prevMatch = function() {
        return this.matchNumber - 1 > 0 && (this.matchNumber -= 1,
        d(this, !1)),
        this.matchNumber
    }
    ,
    h.prototype.version = function() {
        return this.version
    }
    .call({
        version: "1.0.0"
    }),
    h.prototype._testing = function() {
        var e = this;
        return {
            setOpenerTag: function(e) {
                p = e
            },
            setCloserTag: function(e) {
                m = e
            },
            setHighlightCSSClass: function(t) {
                e.HIGHLIGHT_CLASS = t
            },
            findMatches: l
        }
    }
    ,
    e.Match ? e.MatchNoConflict = h : e.Match = h
}(window, document),
define("match", function(e) {
    return function() {
        var t;
        return t || e.Match
    }
}(this)),
define("search-module", ["jquery", "match"], function(e, t) {
    "use strict";
    function a(t, a, i) {
        var r = i
          , o = n.utils.addClass
          , s = n.utils.removeClass
          , c = document.getElementById("word-search-prev")
          , l = document.getElementById("word-search-next")
          , u = function() {
            a >= r + 1 && (r = t.nextMatch(),
            s(c, "disabled")),
            r === a && o(l, "disabled")
        }
          , d = function() {
            r - 1 > 0 && (r = t.prevMatch(),
            s(l, "disabled")),
            1 === r && o(c, "disabled")
        };
        e(document).on("keydown", function(e) {
            var t = 39
              , a = 37;
            switch (e.keyCode) {
            case t:
                u();
                break;
            case a:
                d()
            }
        }),
        a >= r + 1 && s(l, "disabled"),
        r - 1 > 0 && s(c, "disabled"),
        e(c).on("click", d),
        e(l).on("click", u)
    }
    var n = {};
    n.utils = {
        escapeRegExp: function(e) {
            return e.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1")
        },
        sanitizeParam: function(e) {
            return (e || "").replace(/\+/g, " ").replace(/\"/g, "")
        },
        getRegexp: function(e) {
            return new RegExp(this.escapeRegExp(e),"gi")
        },
        getParam: function(e, t) {
            var a = this.escapeRegExp(e) + "=.*?(?=\\&|$)"
              , i = t.match(new RegExp(a), "g");
            return i ? n.utils.sanitizeParam(decodeURIComponent(unescape(i[0]).replace(e + "=", ""))) : null
        },
        replaceParam: function(e, t, a) {
            var n = this.getParam(e, a);
            return null !== n ? a.replace(e + "=" + n, e + "=" + t) : a + "&" + e + "=" + t
        },
        addClass: function(e, t) {
            e && -1 === e.className.indexOf(t) && (e.className += " " + t)
        },
        removeClass: function(e, t) {
            e && e.className.indexOf(t) >= 0 && (e.className = e.className.replace(n.utils.getRegexp(" " + t), ""))
        },
        appendCustomStyles: function(e) {
            var t = document.createElement("style")
              , a = "." + e + "{ background-color: #F5B87F; color: inherit; } body { margin-bottom: 150px; }";
            t.setAttribute("type", "text/css"),
            document.head ? (document.head.appendChild(t),
            t.innerHTML = a) : (document.getElementsByTagName("head")[0].appendChild(t),
            t.styleSheet.cssText = a)
        }
    },
    n.searchBar = function() {}
    ,
    n.searchHighlight = function() {
        var e, i, r, o, s, c, l, u = 0, d = ["q_phrase", "q", "highlight_term"], h = {
            q_search_long_title: "longtitle",
            q_search_short_title: "shorttitle",
            q_sidenote: "sidehead"
        }, f = ["q_search_short_title", "q_search_long_title", "q_sidenote"], p = n.utils, m = !1, g = new t({
            HIGHLIGHT_CLASS: "search-highlight"
        }), b = window.location.search, v = Boolean(p.getParam("whole", b));
        for (n.utils.appendCustomStyles("search-focus"),
        g.clear(),
        e = 0; e < f.length; ) {
            if (o = f[e],
            l = new RegExp(o,"gi").test(b)) {
                if (!h.hasOwnProperty(o)) {
                    console.log("Cannot find selector for", o);
                    continue
                }
                m = !0,
                i = c = null,
                h[o] && (c = document.querySelectorAll("." + h[o]),
                c.length && (i = c)),
                i ? (r = p.getParam(o, b).split(","),
                u += g.search(r, i, {
                    wholeWords: v
                })) : console.log("No section elements selected in DOM for", o)
            }
            e += 1
        }
        if (!m) {
            if (i = document.getElementsByTagName("td"),
            !i)
                return;
            for (e = 0,
            r = []; e < d.length; )
                s = p.getParam(d[e], b),
                s && -1 === r.indexOf(s) && (r = r.concat(s.split(","))),
                e++;
            u += g.search(r, i, {
                wholeWords: v
            })
        }
        u && (a(g, u, 1),
        window.setTimeout(function() {
            g.nextMatch()
        }, 250))
    }
    ,
    n.searchBar(),
    n.searchHighlight()
}),
define("search", ["bootstrap", "search-module"], function(e) {
    "use strict";
    (e("body").is(".index") || e("body").is(".results-page")) && e(".search-toggle").addClass("open");
    var t = e(".search-toggle");
    return e(".search-toggle-btn").on("click", function(a) {
        a.stopPropagation(),
        e(this).toggleClass("open"),
        t.toggleClass("open")
    }),
    e(window).width() < 768 && e(".search-btn>a").trigger("click"),
    function(e) {
        var t = "results-refined-message-hidden"
          , a = sessionStorage.getItem(t);
        a || e("#results-refined-message").removeClass("hide").on("click", function() {
            sessionStorage.setItem(t, !0)
        })
    }(e),
    {}
}),
define("search-refine", ["bootstrap"], function() {
    "use strict";
    return {}
}),
define("social-share", ["jquery"], function(e) {
    "use strict";
    e("#social-share-url-input").val(window.location.href).on("click", function() {
        this.setSelectionRange(0, this.value.length)
    })
}),
define("tooltip", ["bootstrap"], function(e) {
    "use strict";
    function t(t) {
        n.each(function(a, n) {
            var r = e(n)
              , o = i(r.attr("data-tooltip-id"))
              , tooltipContent = t[o.pageId] ? t[o.pageId][o.tooltipId] : "";
              
            // Set both tooltip and aria-label
            var s = {
                title: tooltipContent
            };
            r.tooltip(s);
            
            // Update aria-label with the same content
            r.attr('aria-label', tooltipContent);
        })
    }
    var a = {
        general: {
            "header-search": "Only legislation that has been published in HTML format is searchable",
            "header-search-ga": "Níl ach leaganacha hipearnaisc (leaganacha HTML) den reachtaíocht inchuardaithe ón leathanach cuardaigh ar an eISB."
        },
        homepage: {
            "top-right-title": "This is the most recently published legislation in PDF",
            "top-right-title-ga": "Seo é an Reachtaíocht is déanaí a foilsíodh in PDF"
        },
        "advanced-search": {
            "form-title-only": 'Use double quotation marks for an exact phrase: "child care act" Always use caps for AND, OR, NOT: child AND welfare',
            "form-title-only-ga": 'Bain úsáid as comharthaí dúbailte athfhriotail i gcomhair frása beacht: "acht um chúram leanaí".  Bain úsáid as ceannlitreacha i gcomhair AGUS, NÓ, NÍ: leanbh AGUS leas',
            "form-title-text": 'Use double quotation marks for an exact phrase: "commits an offence" Always use caps for AND, OR, NOT: child OR minor',
            "form-title-text-ga": 'Bain úsáid as comharthaí dúbailte athfhriotail i gcomhair frása beacht: coir a dhéanamh".  Bain úsáid as ceannlitreacha i gcomhair AGUS, NÓ, NÍ: leanbh NÓ mionaoiseach',
            "form-long-title": 'Use double quotation marks for an exact phrase: "child protection" Always use caps for AND, OR, NOT: children AND protection',
            "form-long-title-ga": 'Bain úsáid as comharthaí dúbailte athfhriotail i gcomhair frása beacht: "cosaint leanaí".  Bain úsáid as ceannlitreacha i gcomhair AGUS, NÓ, NÍ: leanbh AGUS cosaint',
            "form-act-no": "Enter number only to search by number.",
            "form-act-no-ga": "Enter number only to search by number.",
            "form-act-section-no": "Use with the Act Number search. Enter section number to search for a specific section of an Act.",
            "form-act-section-no-ga": "Úsáid leis an gcuardach Uimhir Achta. Iontráil uimhir an ailt chun alt ar leith d’Acht a chuardach.",
            "form-years-range": "Specify years or a range to limit your search to Acts and SIs within those years only.",
            "form-years-range-ga": "Sonraigh blianta nó raon chun do chuardach a theorannú d’Achtanna agus IRí laistigh de na blianta sin amháin."
        },
        "act-page": {
            "amendments-post2004": "Information on how this Act has been affected, when it was brought into force and SIs made under it.",
            "revisedAct-post2004": "Link to the Revised Act (administrative consolidation) as produced by the Law Reform Commission including PDF versions with and without annotations.",
            "revisedAct-post2004-ga": "Achtanna Athbhreithnithe. Link to the Revised Act (administrative consolidation) as produced by the Law Reform Commission.",
            "amendments-pre2004": "Information on how this Act has been affected. See the FAQ for information on how to find out if an Act is in force.",
            "amendments-pre2004-ga": "Faisnéis faoin tionchar ar an Acht seo. Féach ar na CCanna le haghaidh faisnéise faoi conas a fháil amach má tá Acht i bhfeidhm. ",
            "revisedAct-pre2004": "Unofficial version of the Act as amended. It will be displayed here if available.",
            "amendments-pre1922": "Information on how Act has been affected.",
            "amendments-si": "See how this SI has been affected. Only amendments made by Acts and SIs from 1923 onwards are included.",
            "revisedAct-button": "Unofficial version of the Act as amended. It will be displayed here if available.",
            "amendments-button": "Information on how this Act has been affected. See the FAQ for information on how to find out if an Act is in force.",
            "bill-history": "Link to Houses of the Oireachtas website containing versions of the Bill during its passage through the Houses, Committee and Report stage amendments and debates.",
        }
    }
    , n = e("[data-tooltip-id]")
    , i = function(e) {
      var t = (e || "").split("_");
      return {
          pageId: t[0],
          tooltipId: t[1]
      }
  };

  return t(a),
  n.on("click", function(e) {
      e.stopPropagation(),
      e.preventDefault()
  }),
  {}
}),
define("print", ["jquery"], function(e) {
    "use strict";
    var t = /printonload=true/gi
      , a = window.location.search;
    a.match(t) && window.print(),
    e(".btn-print-section").on("click", function(e) {
        e.stopPropagation(),
        window.print()
    })
}),
define("toggle", ["jquery", "js-cookie"], function(e, t) {
    "use strict";
    var a = t.get("eisb_lang");
    if (a && "English" !== a) {
        e(".english_language").hide(),
        e(".irish_language").show();
        var n = e('a[href="#tab-acts"]')
          , i = e('a[href="#tab-statutory"]');
        n.text("Achtanna"),
        i.text("Ionstraimí Reachtúla"),
        e("#js-datatables-year-filter > option:eq(0)").text("Cineál Bliain"),
        e("#js-datatables-year-filter").trigger("change.select2"),
        e("#title.form-control").attr("placeholder", "Cuardaigh an teideal amháin"),
        e("#title.form-control").attr("placeholder", "Cuardaigh an teideal amháin"),
        e("#body.form-control").attr("placeholder", "Cuardaigh an teideal agus an téacs "),
        e("#longtitle.form-control").attr("placeholder", "Cuardaigh an teideal fada amháin"),
        e("#number.form-control").attr("placeholder", "Uimhir Achta / IR"),
        e("#secNum.form-control").attr("placeholder", "Uimhir Ailt")
    } else
        t.set("eisb_lang", "English"),
        e(".english_language").show(),
        e(".irish_language").hide();
    e(".language_toggle").on("click", function() {
        var a = e(this).text()
          , n = e('a[href="#tab-acts"]')
          , i = e('a[href="#tab-statutory"]');
        "Gaeilge" === a ? (e(".english_language").hide(),
        e(".irish_language").show(),
        n.text("Achtanna"),
        i.text("Ionstraimí Reachtúla"),
        e("#js-datatables-year-filter > option:eq(0)").text("Cineál Bliain"),
        e("#js-datatables-year-filter").trigger("change.select2"),
        e("#title.form-control").attr("placeholder", "Cuardaigh an teideal amháin"),
        e("#body.form-control").attr("placeholder", "Cuardaigh an teideal agus an téacs "),
        e("#longtitle.form-control").attr("placeholder", "Cuardaigh an teideal fada amháin"),
        e("#number.form-control").attr("placeholder", "Uimhir Achta / IR"),
        e("#secNum.form-control").attr("placeholder", "Uimhir Ailt")) : "English" === a && (e(".english_language").show(),
        e(".irish_language").hide(),
        n.text("Acts"),
        i.text("Statutory Instruments"),
        e("#js-datatables-year-filter > option:eq(0)").text("Type Year"),
        e("#js-datatables-year-filter").trigger("change.select2"),
        e("#title.form-control").attr("placeholder", "Search title only"),
        e("#body.form-control").attr("placeholder", "Search title and text"),
        e("#longtitle.form-control").attr("placeholder", "Search long title only"),
        e("#number.form-control").attr("placeholder", "Act / SI Number"),
        e("#secNum.form-control").attr("placeholder", "Section number")),
        t.set("eisb_lang", a)
    })
}),
function(e) {
    "use strict";
    var t = "/bower_components/"
      , a = {
        deps: ["jquery"],
        exports: "$"
    }
      , n = {
        baseUrl: "static/javascript/",
        paths: {
            jquery: t + "jquery/jquery",
            "js-cookie": t + "js-cookie/src/js.cookie",
            bootstrap: t + "bootstrap/dist/js/bootstrap",
            datatables: t + "DataTables/media/js/jquery.dataTables",
            select2: t + "select2/select2",
            handlebars: t + "handlebars/handlebars.amd",
            xmlToJSON: t + "xmlToJSON.js/lib/xmlToJSON",
            match: "/static/lib/match.min"
        },
        shim: {
            bootstrap: a,
            datatables: a,
            select2: a,
            xmlToJSON: {
                exports: "xmlToJSON"
            },
            match: {
                exports: "Match"
            }
        }
    };
    e.config(n),
    e(["acts-sticky-header", "acts-year-select", "cookies", "datatable-init", "dropdown", "faq", "feedback", "home-image", "legislation-pdf", "navbar", "scrollTop", "search", "search-refine", "social-share", "tooltip", "print", "toggle"])
}(require),
define("main", function() {});
//# sourceMappingURL=eisb.min.js.map
